import React, { useCallback } from "react";
import styled, { css } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation, Link, useHistory } from "react-router-dom";
import guide from "services/guide";
import logger from "utils/logger";

const StyledSideNavBar = styled.nav`
  align-self: flex-end;
  width: 100%;
  margin-top: 20px;
  padding: 25px 15px;
  color: ${({ theme }) => theme.fontColor};
  background-color: transparent;
  display: flex;
  flex-direction: column;
  row-gap: 35px;
  position: relative;

  ::before {
    content: "";
    position: absolute;
    right: 8px;
    top: 0;
    height: 100%;
    width: 2px;
    background-color: ${({ theme }) => theme.black};
    box-shadow: ${({ theme }) => theme.boxShadow};
  }
`;

const StyledIcon = styled(FontAwesomeIcon)`
  font-size: ${({ theme }) => theme.fontSize.xsmall};
  width: 12px;
`;

const activeItemCss = css`
  opacity: 1;
  color: ${({ theme }) => theme.dark};
  ::after {
    opacity: 1;
  }
`;

const StyledNavBarItem = styled.div`
  cursor: ${({ disabled }) => !disabled && "pointer"};
  width: 100%;
  opacity: 0.9;
  transition: 0.2s;

  display: grid;
  grid-template-columns: 12px 60px;
  column-gap: 12px;
  justify-content: end;
  padding-right: 20px;

  position: relative;
  ::after {
    content: "";
    position: absolute;
    top: 50%;
    margin-top: -6px;
    right: -12px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 7px 0 7px 7px;
    border-color: transparent transparent transparent
      ${({ theme }) => theme.black};
    opacity: 0;
    transition: 0.2s;
    /* background-color: ${({ theme }) => theme.dark}; */
    /* width: 6px;
    height: 6px; */
    /* right: 15px; */
    /* border-radius: 50%; */
    /* background-color: ${({ theme }) => theme.gray}; */
  }

  :hover {
    ${({ disabled }) => !disabled && activeItemCss}
  }

  ${({ active }) => active && activeItemCss}
`;

const StyledLink = styled(Link)`
  font-size: ${({ theme }) => theme.fontSize.small};
  color: unset;
  text-decoration: unset;
  letter-spacing: 1.5px;
`;

const StyledSpan = styled.span`
  font-size: ${({ theme }) => theme.fontSize.small};
  color: unset;
  letter-spacing: 1.5px;
`;

const SideNavBar = () => {
  const location = useLocation();
  const history = useHistory();

  const handleClick = useCallback(() => {
    logger.log(history);
  }, [history]);

  const guideList = [
    guide.pages.pluginInfo.basePath,
    guide.pages.pluginUpload.basePath,
    guide.pages.historyVer.basePath,
    guide.pages.overtimeVer.basePath,
  ]
  return (
    <StyledSideNavBar>
      {guide.barItems.map((item) => (
        <StyledNavBarItem
          key={item.basePath}
          active={RegExp("^" + item.basePath + "/?").test(location.pathname)}
          disabled={(guide.pages.page404.basePath === item.basePath || guide.pages.pluginVer.basePath === item.basePath)}
        >
          <StyledIcon icon={item.icon} />
          {guideList.includes(item.basePath) ? (
            <StyledLink to={item.basePath}>{item.name}</StyledLink>
          ) : (
            <StyledSpan onClick={handleClick}>{item.name}</StyledSpan>
          )}
        </StyledNavBarItem>
      ))}
    </StyledSideNavBar>
  );
};

export default SideNavBar;
